import React, { createContext, ReactNode, useContext } from "react";

import { IChapterProjectService } from "../types/services/chapter-project-service";

const ChapterProjectServiceContext = createContext<IChapterProjectService>(
  undefined as any,
);

interface ChapterProjectServiceProviderProps {
  children: ReactNode;
  service: IChapterProjectService;
}

function ChapterProjectServiceProvider(
  props: ChapterProjectServiceProviderProps,
) {
  const { children, service } = props;

  return (
    <ChapterProjectServiceContext.Provider value={service}>
      {children}
    </ChapterProjectServiceContext.Provider>
  );
}

function useChapterProjectService() {
  return useContext(ChapterProjectServiceContext);
}

export { ChapterProjectServiceProvider, useChapterProjectService };
